package com.karyadina.util

actual fun formatDateShort(timeMillis: Long): String {
    val now = currentTimeMillis()
    val dayMs = 24 * 60 * 60 * 1000
    
    val dayStart = (timeMillis / dayMs) * dayMs
    val todayStart = (now / dayMs) * dayMs
    
    val daysBack = ((todayStart - dayStart) / dayMs).toInt()
    
    return when (daysBack) {
        0 -> "Today"
        1 -> "Yesterday"
        else -> {
            // Calculate date components from milliseconds (UTC-based)
            // Days since epoch (Jan 1, 1970)
            val daysSinceEpoch = timeMillis / dayMs
            
            // Simple month/day calculation (approximation for display)
            // Month names array
            val monthNames = arrayOf("Jan", "Feb", "Mar", "Apr", "May", "Jun", 
                                     "Jul", "Aug", "Sep", "Oct", "Nov", "Dec")
            
            // Leap year checker
            fun isLeapYear(year: Int): Boolean = (year % 4 == 0 && year % 100 != 0) || (year % 400 == 0)
            
            // Days per month
            fun daysInMonth(month: Int, year: Int): Int {
                return if (month == 1) {
                    if (isLeapYear(year)) 29 else 28
                } else {
                    arrayOf(31, 0, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31)[month]
                }
            }
            
            // Calculate year, month, day
            var remainingDays = daysSinceEpoch.toInt()
            var year = 1970
            
            while (true) {
                val daysInYear = if (isLeapYear(year)) 366 else 365
                if (remainingDays < daysInYear) break
                remainingDays -= daysInYear
                year++
            }
            
            var month = 0
            var day = remainingDays
            while (month < 12) {
                val daysInCurrentMonth = daysInMonth(month, year)
                if (day < daysInCurrentMonth) break
                day -= daysInCurrentMonth
                month++
            }
            day++ // Days are 1-indexed
            
            "${monthNames[month]} $day"
        }
    }
}
